import styled from 'styled-components'

import { helpers } from 'styles'

export const List = styled.div`
	margin: ${helpers.spacing.small} 0;
`
